import 'dotenv/config';
import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist'

Vue.use(Vuex);
const DEPLOYMENT = 'eu-1'; // (process.env.DEPLOYMENT === 'development' ? 'eu-1' : 'eu-1'); //sandbox
console.log('DEPLOYMENT', DEPLOYMENT , process.env.DEPLOYMENT );

const vuexLocalStorage = new VuexPersist({
    key: 'vuex',
    storage: window.sessionStorage, // or window.sess√ionStorage or localForage
    // Function that passes the state and returns the state with only the objects you want to store.
    reducer: state => state,
    // Function that passes a mutation and lets you decide if it should update the state in localStorage.
    // filter: mutation => (true)
})
/** /
    enviromentURL: 'https://challenge-admin.sandbox.pixcham.com',
    enviromentBasicURL: 'https://challenge.sandbox.pixcham.com',
    enviromentCDN: 'https://sandbox-pixcham-cdn-challenge.s3.amazonaws.com/',
    enviromentAdminURL: 'https://challenge-admin.sandbox.pixcham.com',
/** /
    enviromentURL: 'https://challenge-admin.eu-1.pixcham.com',
    enviromentBasicURL: 'https://challenge.eu-1.pixcham.com',
    enviromentCDN: 'https://sandbox-pixcham-cdn-challenge.s3.amazonaws.com/',
    enviromentAdminURL: 'https://challenge-admin.eu-1.pixcham.com',
/**/

export default new Vuex.Store({
    //});
    //export default new Vuex.Store({
    state: {
        enviroment: 'eu-1',//'-staging',// in linv
        liveEnviroment: 'eu-1',
        /**/
        enviromentURL: `https://challenge-admin.${DEPLOYMENT}.pixcham.com`,
        enviromentBasicURL: `https://challenge.${DEPLOYMENT}.pixcham.com`,
        enviromentCDN: `https://pixcham-cdn-challenge.s3.amazonaws.com/`,
        enviromentPlayerAdminURL: `https://admin.${DEPLOYMENT}.pixcham.com`,
        enviromentAdminURL: `https://challenge-admin.${DEPLOYMENT}.pixcham.com`,
        objectiveUrl: `https://pixcham-cdn.s3.amazonaws.com/objective`,
        
        /**c/
        enviromentURL: 'https://challenge-admin.eu-1.pixcham.com',
        enviromentBasicURL: 'https://challenge.eu-1.pixcham.com',
        enviromentCDN: 'https://sandbox-pixcham-cdn-challenge.s3.amazonaws.com/',
        enviromentPlayerAdminURL: 'https://admin.eu-1.pixcham.com',
        enviromentAdminURL: 'https://challenge-admin.eu-1.pixcham.com',
        objectiveUrl: 'https://pixcham-cdn.s3.eu-central-1.amazonaws.com/objective',
        /**/
        enviromentAuthURL: 'https://auth.eu-1.pixcham.com',
        activeLang: 'en',
        activeCountry: 'en-gb',
        manualyChangedCountry: false,
        openCountries: false,
        currency: '$',
        accountTypes: {
            0: 'individual',
            1: 'business',
        },
        activeOverlay: false,
        userAccountType: 'individual',
        userLoggedIn: false,
        dashboardType: 'user',
        userInfluencer: false,
        credit: 0,
        userName: false,
        companyName: false,
        userUniq: '',
        companyUniq: '',
        taskRound: {}, 
        verified: false,
        userPrivileges: [],
        confirmOpen: false,
        bidsOpen: false,
        bidsLits: [],
        selectedSlot: '',
        selectedChID: '',
        paySuccess: false,
        selectedEID: '',
        selectedMChID:[],
        selectedDay: '',
        selectedMonth: '',
        selectedMonthName: '',
        selectedYear: '',
        selectedLocation: {},
        selectedLocationName: '',
        selectedLocationType: '',
        selectedLocationCCode: '',
        selectedPrice: '',
        saveBasic: null,
        saveRounds: null,
        savePrizes: null,
        saveTranslations: null,
        keywordOpen: false,
        keywordChallengeOpen: false,
        fixedMain: false,
        templateSetup: false,
        showCountries: false,
        addUserOpen: false,
        sendEmailOpen: false,
        showFeedback: false,
        addMemberOpen: false,
        openConfirmBox: false,
        addTranslation: false,
        showPrizeProvider: false,
        addTranslationPrize: false,
        addTranslationTask: false,
        editTranslationTask: false,
        addTranslationTaskBasic: false,
        editUser: false,
        deliveryAddressOpen: false,
        addEmailOpen: false,
        companyID: 0,
        company: {},
        editChallengeOpen: false,
        generatePromoCode: false,
        reportStatisticsOpen: false,
        keywordEditOpen: false,
        languageOpen: false,
        translationsOpen: false,
        editEmailTranslationsOpen: false,
        translationsTaskOpen: false,
        movePlayers: false,
        redirectTo: '/',
        redirectToValue: '',
        setOffset: null,
        successOpen: false,
        successOpenMessage: null,
        successSender: null,
        customAlert: false,
        missingThings: false,
        days: {
            1: {
                value: 1,
                name: 'monday',
                short: 'mo',
            },
            2: {
                value: 2,
                name: 'tuesday',
                short: 'tu',
            },
            3: {
                value: 3,
                name: 'wednesday',
                short: 'we',
            },
            4: {
                value: 4,
                name: 'thursday',
                short: 'th',
            },
            5: {
                value: 5,
                name: 'friday',
                short: 'fr',
            },
            6: {
                value: 6,
                name: 'saturday',
                short: 'sa',
            },
            7: {
                value: 7,
                name: 'sunday',
                short: 'su',
            }
        },
        months: {
            0: {
                value: 1,
                name: 'january',
                short: 'jan',
            },
            1: {
                value: 2,
                name: 'february',
                short: 'feb',
            },
            2: {
                value: 3,
                name: 'march',
                short: 'mar',
            },
            3: {
                value: 4,
                name: 'april',
                short: 'apr',
            },
            4: {
                value: 5,
                name: 'may',
                short: 'may',
            },
            5: {
                value: 6,
                name: 'june',
                short: 'jun',
            },
            6: {
                value: 7,
                name: 'july',
                short: 'jul',
            },
            7: {
                value: 8,
                name: 'august',
                short: 'aug',
            },
            8: {
                value: 9,
                name: 'september',
                short: 'sep',
            },
            9: {
                value: 10,
                name: 'october',
                short: 'oct',
            },
            10: {
                value: 11,
                name: 'november',
                short: 'nov',
            },
            11: {
                value: 12,
                name: 'december',
                short: 'dec',
            }
        },
        years: {
            0: '2021'
        }
    },

    getters: {
        enviroment: state => state.enviroment,
        enviromentURL: state => state.enviromentURL,
        enviromentBasicURL: state => state.enviromentBasicURL,
        enviromentAdminURL: state => state.enviromentAdminURL,
        objectiveUrl: state => state.objectiveUrl,
        enviromentPlayerAdminURL: state => state.enviromentPlayerAdminURL,
        enviromentAuthURL: state => state.enviromentAuthURL,
        enviromentCDN: state => state.enviromentCDN,
        currency: state => state.currency,
        locationsStored: state => state.selectedLocation,
        userLoggedIn: state => state.userLoggedIn,
        dashboardType: state => state.dashboardType,
        userInfluencer: state => state.userInfluencer,
        userPrivileges: state => state.userPrivileges,
        activeLang: state => state.activeLang,
        activeCountry: state => state.activeCountry,
        manualyChangedCountry: state => state.manualyChangedCountry,
        activeOverlay: state => state.activeOverlay,
        bidsList: state => state.bidsList,
        bidsOpen: state => state.bidsOpen,
        confirmOpen: state => state.confirmOpen,
        keywordOpen: state => state.keywordOpen,
        keywordChallengeOpen: state => state.keywordChallengeOpen,
        openCountries: state => state.openCountries,
        templateSetup: state => state.templateSetup,
        fixedMain: state => state.fixedMain,
        showCountries: state => state.showCountries,
        addUserOpen: state => state.addUserOpen,
        sendEmailOpen: state => state.sendEmailOpen,
        showFeedback: state => state.showFeedback,
        addMemberOpen: state => state.addMemberOpen,
        openConfirmBox: state => state.openConfirmBox,
        addTranslation: state => state.addTranslation,
        showPrizeProvider: state => state.showPrizeProvider,
        addTranslationPrize: state => state.addTranslationPrize,
        addTranslationTask: state => state.addTranslationTask,
        openMissingThings: state => state.missingThings,
        editTranslationTask: state => state.editTranslationTask,
        addTranslationTaskBasic: state => state.addTranslationTaskBasic,
        editUser: state => state.editUser,
        deliveryAddressOpen: state => state.deliveryAddressOpen,
        addEmailOpen: state => state.addEmailOpen,
        companyID: state => state.companyID,
        company: state => state.company,
        credit: state => state.credit,
        userName: state => state.userName,
        companyName: state => state.companyName,
        userUniq: state => state.userUniq,
        companyUniq: state => state.companyUniq,
        taskRound: state => state.taskRound,
        verified: state => state.verified,
        editChallengeOpen: state => state.editChallengeOpen,
        generatePromoCode: state => state.generatePromoCode,
        reportStatisticsOpen: state => state.reportStatisticsOpen,
        keywordEditOpen: state => state.keywordEditOpen,
        languageOpen: state => state.languageOpen,
        translationsOpen: state => state.translationsOpen,
        editEmailTranslationsOpen: state => state.editEmailTranslationsOpen,
        translationsTaskOpen: state => state.translationsTaskOpen,
        movePlayers: state => state.movePlayers,
        successOpen: state => state.successOpen,
        successOpenMessage: state => state.successOpenMessage,
        successSender: state => state.successSender,
        customAlert: state => state.customAlert,
        saveBasic: state => state.saveBasic,
        saveRounds: state => state.saveRounds,
        savePrizes: state => state.savePrizes,
        saveTranslations: state => state.saveTranslations,
        redirectTo: state => state.redirectTo,
        redirectToValue: state => state.redirectToValue
    },

    mutations: {
        updateActiveLang(state, activeLang) {
            state.activeLang = activeLang
        },
        updateActiveCountry(state, activeCountry) {
            state.activeCountry = activeCountry
        },
        updateManualyChangedCountry(state, manualyChangedCountry) {
            state.manualyChangedCountry = manualyChangedCountry
        },
        updateUserLoggin(state, userLoggedIn) {
            state.userLoggedIn = userLoggedIn
        },
        updateDashboardType(state, dashboardType) {
            state.dashboardType = dashboardType
        },
        updateUserInfluencer(state, userInfluencer) {
            state.userInfluencer = userInfluencer
        },
        updateUserPrivileges(state, userPrivileges) {
            state.userPrivileges = userPrivileges
        },
        updateUserAccountType(state, userAccountType) {
            state.userAccountType = userAccountType
        },
        updateSelectedDay(state, selectedDay) {
            state.selectedDay = selectedDay
        },
        updateSelectedMonth(state, selectedMonth) {
            state.selectedMonth = selectedMonth
        },
        updateSelectedMonthName(state, selectedMonthName) {
            state.selectedMonthName = selectedMonthName
        },
        updateSelectedYear(state, selectedYear) {
            state.selectedYear = selectedYear
        },
        updateSelectedLocation(state, selectedLocation) {
            state.selectedLocation = selectedLocation
        },
        updateSelectedLocationName(state, selectedLocationName) {
            state.selectedLocationName = selectedLocationName
        },
        updateSelectedLocationType(state, selectedLocationType) {
            state.selectedLocationType = selectedLocationType
        },
        updateSelectedLocationCCode(state, selectedLocationCCode ) {
            state.selectedLocationCCode = selectedLocationCCode
        },
        updateSelectedSlot(state, selectedSlot) {
            state.selectedSlot = selectedSlot
        },
        updateSelectedSlotPrice(state, selectedSlotPrice) {
            state.selectedSlotPrice = selectedSlotPrice
        },
        updateSelectedSlotBids(state, selectedSlotBids) {
            state.selectedSlotBids = selectedSlotBids
        },
        updateSelectedPrice(state, selectedPrice) {
            state.selectedPrice = selectedPrice
        },
        updateSelectedChID(state, selectedChID) {
            state.selectedChID = selectedChID
        },
        updatePaySuccess(state, paySuccess) {
            state.paySuccess = paySuccess
        },
        updateSetOffset(state, setOffset) {
            state.setOffset = setOffset
        },
        updateSelectedEID(state, selectedEID) {
            state.selectedEID = selectedEID
        },
        updateSelectedMChID(state, selectedMChID) {
            state.selectedMChID = selectedMChID
        },
        updateSaveBasic(state, saveBasic) {
            state.saveBasic = saveBasic
        },
        updateSaveRounds(state, saveRounds) {
            state.saveRounds = saveRounds
        },
        updateSavePrizes(state, savePrizes) {
            state.savePrizes = savePrizes
        },
        updateSaveTranslations(state, saveTranslations) {
            state.saveTranslations = saveTranslations
        },
        updateSelectedActiveTab(state, activeTab) {
            state.activeTab = activeTab
        },
        updateBidsList(state, bidsLits) {
            state.bidsLits = bidsLits
        },
        updateBidsOpen(state, bidsOpen) {
            state.bidsOpen = bidsOpen
        },
        updateActiveOverlay(state, activeOverlay) {
            state.activeOverlay = activeOverlay
        },
        updateConfirmOpen(state, confirmOpen) {
            state.confirmOpen = confirmOpen
        },
        updateKeywordOpen(state, keywordOpen) {
            state.keywordOpen = keywordOpen
        },
        updateKeywordChallengeOpen(state, keywordChallengeOpen) {
            state.keywordChallengeOpen = keywordChallengeOpen
        },
        updateOpenCountries(state, openCountries) {
            state.openCountries = openCountries
        },
        updateFixedMain(state, fixedMain) {
            state.fixedMain = fixedMain
        },
        updateTemplateSetup(state, templateSetup) {
            state.templateSetup = templateSetup
        },
        updateShowCountries(state, showCountries) {
            state.showCountries = showCountries
        },
        addUserOpen(state, addUserOpen) {
            state.addUserOpen = addUserOpen
        },
        sendEmailOpen(state, sendEmailOpen) {
            state.sendEmailOpen = sendEmailOpen
        },
        showFeedback(state, showFeedback) {
            state.showFeedback = showFeedback
        },
        addMemberOpen(state, addMemberOpen) {
            state.addMemberOpen = addMemberOpen
        },
        openConfirmBox(state, openConfirmBox) {
            state.openConfirmBox = openConfirmBox
        },
        addTranslation(state, addTranslation) {
            state.addTranslation = addTranslation
        },
        showPrizeProvider(state, showPrizeProvider) {
            state.showPrizeProvider = showPrizeProvider
        },
        addTranslationPrize(state, addTranslationPrize) {
            state.addTranslationPrize = addTranslationPrize
        },
        addTranslationTask(state, addTranslationTask) {
            state.addTranslationTask = addTranslationTask
        },
        openMissingThings(state, missingThings) {
            state.missingThings = missingThings
        },
        editTranslationTask(state, editTranslationTask) {
            state.editTranslationTask = editTranslationTask
        },
        addTranslationTaskBasic(state, addTranslationTaskBasic) {
            state.addTranslationTaskBasic = addTranslationTaskBasic
        },
        editUser(state, editUser) {
            state.editUser = editUser
        },
        deliveryAddressOpen( state, deliveryAddressOpen )
        {
            state.deliveryAddressOpen = deliveryAddressOpen                                                                           
        },
        addEmailOpen(state, addEmailOpen) {
            state.addEmailOpen = addEmailOpen
        },
        companyID(state, companyID) {
            state.companyID = companyID
        },
        updateCompany(state, company) {
            state.company = company
        },
        credit(state, credit) {
            state.credit = credit
        },
        userName(state, userName) {
            state.userName = userName
        },
        companyName(state, companyName) {
            state.companyName = companyName
        },
        userUniq(state, userUniq) {
            state.userUniq = userUniq
        },
        companyUniq(state, companyUniq) {
            state.companyUniq = companyUniq
        },
        updateTaskRound(state, taskRound) {
            state.taskRound = taskRound
        },
        verified(state, verified) {
            state.verified = verified
        },
        editChallengeOpen(state, editChallengeOpen) {
            state.editChallengeOpen = editChallengeOpen
        },
        generatePromoCode(state, generatePromoCode) {
            state.generatePromoCode = generatePromoCode
        },
        reportStatisticsOpen(state, reportStatisticsOpen) {
            state.reportStatisticsOpen = reportStatisticsOpen
        },
        updateKeywordEditOpen(state, keywordEditOpen) {
            state.keywordEditOpen = keywordEditOpen
        },
        updateLanguageOpen(state, languageOpen) {
            state.languageOpen = languageOpen
        },
        updateTranslationsOpen(state, translationsOpen) {
            state.translationsOpen = translationsOpen
        },
        updateEditEmailTranslationsOpen(state, editEmailTranslationsOpen) {
            state.editEmailTranslationsOpen = editEmailTranslationsOpen
        },
        updateTranslationsTaskOpen(state, translationsTaskOpen) {
            state.translationsTaskOpen = translationsTaskOpen
        },
        updateMovePlayers(state, movePlayers) {
            state.movePlayers = movePlayers
        },
        updateRedirectTo(state, redirectTo) {
            state.redirectTo = redirectTo
        },
        updateRedirectToValue(state, redirectToValue) {
            state.redirectToValue = redirectToValue
        },
        updateSuccessOpen(state, successOpen) {
            state.successOpen = successOpen
        },
        updateSuccessOpenMessage(state, successOpenMessage) {
            state.successOpenMessage = successOpenMessage
        },
        updateSuccessSender(state, successSender) {
            state.successSender = successSender
        },
        updateCustomAlert(state, customAlert) {
            state.customAlert = customAlert
        },
    },

    actions: {
    },

    plugins: [vuexLocalStorage.plugin]
});
